import { createStore, sample } from 'effector'
import { goOnPrivateError } from '@/app/routing/events'
import { getUserProfileFx } from '@/entities/user'
import { EpicUserData } from './types/types'

export const $epicUserData = createStore<null | EpicUserData>(null).on(getUserProfileFx.doneData, (_, data) => {
  if (data.epic_data == null && data.user.epic_update_in_progress === false) {
    sample({
      clock: $epicUserData,
      filter: (epicData) => epicData === null,
      target: goOnPrivateError,
    })
  }
  if (!data.epic_data) {
    return null
  }
  return {
    ...data?.epic_data,
    epic_gigi: data?.user?.epic_token_value ?? 0,
    updating: data?.user?.epic_update_in_progress ?? false,
  }
})